"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.principalFactory = void 0;
const Factory = require("factory.ts");
const uuid_1 = require("uuid");
exports.principalFactory = Factory.Sync.makeFactory({
    extended_attributes: {},
    id: Factory.each(() => uuid_1.v4()),
    principal_id: Factory.each(() => uuid_1.v4()),
    principal_originator_id: Factory.each(() => uuid_1.v4()),
    principal_originator_system: 'Ngin',
    principal_originator_type: 'event',
    principal_type: 'event'
});
